import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn", "onItemClick", "description", "header", "navMarker", "errorMarker", "direction", "size", "flush", "resultTypes", "inferenceSource", "onInterest", "onNegativeFeedback", "cardsContainerProps"];
import { CardsSection } from '../../cardsSection';
import { useRef, useState } from 'react';
import Raven from 'raven-js';
import { useRecommendationsState } from '../recommendationsStore';
import { usePostRankedRecommendationsFeedback } from 'academy-common-lib/features/recommendations/hooks/usePostRankedRecommendationsFeedback';
import { useRankedRecommendationsContent } from 'academy-common-lib/features/recommendations/hooks/useRankedRecommendationsContent';
import { InterestFeedbackTracker } from 'academy-common-lib/components/feedback/InterestFeedbackTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const RankedRecommendationsWithNegativeFeedback = _ref => {
  let {
      appearsIn,
      onItemClick,
      description,
      header,
      navMarker,
      errorMarker,
      direction,
      size,
      flush,
      resultTypes,
      inferenceSource,
      onInterest,
      onNegativeFeedback,
      cardsContainerProps
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [maxCards, setMaxCards] = useState();
  const hasSentPositiveFeedbackRef = useRef(false);
  const {
    content,
    loading,
    error,
    correlationId
  } = useRankedRecommendationsContent({
    maxCards,
    inferenceSource,
    types: resultTypes
  });
  const {
    postRankedRecommendationsFeedback
  } = usePostRankedRecommendationsFeedback();
  const {
    setLastClickedRecommendationItem
  } = useRecommendationsState();
  const handleOnItemClick = (item, index) => {
    if (!hasSentPositiveFeedbackRef.current && correlationId && content) {
      hasSentPositiveFeedbackRef.current = true;
      postRankedRecommendationsFeedback({
        entityType: item.type,
        entityId: item.id,
        correlationId,
        content
      }).catch(Raven.captureException.bind(Raven));
      setLastClickedRecommendationItem({
        correlationId,
        item: {
          id: item.id,
          type: item.type
        },
        recommendationEngine: 'ranked'
      });
    }
    onItemClick === null || onItemClick === void 0 || onItemClick(item, index);
  };
  const handleOnNegativeFeedback = () => {
    if (!correlationId || !content) return;
    onNegativeFeedback === null || onNegativeFeedback === void 0 || onNegativeFeedback();
    postRankedRecommendationsFeedback({
      correlationId,
      content
    }).catch(Raven.captureException.bind(Raven));
  };
  return /*#__PURE__*/_jsx(InterestFeedbackTracker, {
    bypassTrackingRef: hasSentPositiveFeedbackRef,
    onInterest: onInterest,
    onNegativeFeedback: handleOnNegativeFeedback,
    children: /*#__PURE__*/_jsx(CardsSection, Object.assign({
      appearsIn: appearsIn,
      cardsContainerProps: cardsContainerProps,
      content: content,
      description: description,
      direction: direction,
      error: error,
      errorMarker: errorMarker,
      flush: flush,
      header: header,
      isLoading: loading,
      maxSkeletonListLength: 3,
      navMarker: !loading && !error ? navMarker : undefined,
      onItemClick: handleOnItemClick,
      onItemMenuClick: handleOnItemClick,
      setMaxCards: setMaxCards,
      size: size
    }, props))
  });
};